import Channel from '../../../classes/channel';
import { createContext, Dispatch, SetStateAction } from 'react';

const ManageChannelContext = createContext<{
  allChannels?: Channel[];
  originalChannels?: Channel[];
  editing: boolean;
  restoreChannels?: () => void;
  setChannels?: (channels: Channel[]) => void;
  setEditing: Dispatch<SetStateAction<boolean>>;
}>({ editing: false, setEditing: () => null });

export default ManageChannelContext;
